export class MedicalExamCertificateWaiver {
    public waiverTypeId: number;
    public effectiveDate: Date;
    public expirationDate: Date;
}
